import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { MENU_TYPES } from 'dpl/decorators/withMobileMenu';
import { makeSequence } from 'dpl/shared/utils';


export default function GlobalMobileMenuNavigationButton({
  closeMenu,
  openMobileMenuName,
  openNavigationMenu,
  hasNotifications
}) {
  const isOpen = openMobileMenuName === MENU_TYPES.NAVIGATION;

  return (
    <div
      className={
        classnames(
          'GlobalMobileMenuNavigationButton relative mt2 mr0 ml-auto',
          { 'GlobalMobileMenuNavigationButton--open': isOpen }
        )
      }
    >
      <button
        type="button"
        onClick={ isOpen ? closeMenu : openNavigationMenu }
        className="GlobalMobileMenuNavigationButton__button w-100 no-select relative"
        aria-label="user header menu"
        data-test="mobile_header_actions_button"
      >
        <div>
          {
            makeSequence(3).map(idx => (
              <span
                key={ idx }
                className="GlobalMobileMenuNavigationButton__line db relative bg-white z-1 transition bg-purple w-100"
              />
            ))
          }
        </div>

        {
          !isOpen && hasNotifications &&
            <span className="pv1 ph1 bg-red absolute ba bw1 b--white br-100 right-0 top-0 nh2 nv2 z-1" />
        }
      </button>
    </div>
  );
}

GlobalMobileMenuNavigationButton.propTypes = {
  closeMenu: PropTypes.func.isRequired,
  openMobileMenuName: PropTypes.string,
  openNavigationMenu: PropTypes.func.isRequired,
  hasNotifications: PropTypes.bool
};

GlobalMobileMenuNavigationButton.defaultProps = {
  openMobileMenuName: null,
  hasNotifications: false
};
